/**
 * The view model for the errors that come from the server.
 */
export interface ErrorViewModel {
  title: string;
  statusCode: string;
  value?: IErrorViewModelValue | null;
}

export interface IErrorViewModelValue {
  description: string | null;
  statusCode?: string | null;
}

/**
 * @param error Type guard for ErrorViewModel
 */
export function isErrorViewModel(error: ErrorViewModel | any): error is ErrorViewModel {
  return (error as ErrorViewModel).title !== undefined || (error as ErrorViewModel).value !== undefined;
}
